
webpack.register(
    'components/modal-dialog/modal-dialog',
    function() {
        return require('components/modal-dialog/modal-dialog');
    },
    false
);
webpack.register(
    'components/image-universal/image-universal',
    function() {
        return require('components/image-universal/image-universal');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from='components/modal-dialog/modal-dialog'/>\r\n<can-import from='components/image-universal/image-universal'/>\r\n\r\n<modal-dialog {image}=\"image\" {link}=\"link\" {class-name}=\"'s-geo-targeted-interstitial-modal'\">\r\n    <a href=\"{{link.url}}\" {{#is link.target \"new\"}}target=\"_blank\"{{/is}} class=\"c-geo-targeted-interstitial\">\r\n        <image-universal {visible}=\"true\" {image}=\"image\" {crop}=\"'fit'\" class-name=\"s-geo-targeted-interstitial__image\"></image-universal>\r\n    </a>\r\n</modal-dialog>\r\n");